import { fetch, getDomainsPaths, resolvePageDataPath } from '@/utils';

import HeadSeo from '@/components/_App/HeadSeo';
import HeroSlider from '@/components/HeroSlider';

import { ADDITIONAL_ROUTES } from '@/data/pages/routes';
import AboutUsSection from '@/components/AboutUsSection';
import { AboutUsInterface } from '@/types/components/AboutUs';

export default function AboutUsPage({
  heroSlides,
  data,
  dataHome,
}: AboutUsInterface) {
  return (
    <>
      <HeadSeo
        title={ADDITIONAL_ROUTES.aboutUs.title}
        description={ADDITIONAL_ROUTES.aboutUs.description}
      />
      <HeroSlider
        heroImage={dataHome.heroImage}
        title={dataHome.heroText}
        description={dataHome.description}
        data={heroSlides}
      />
      <AboutUsSection data={data} />
    </>
  );
}

export async function getStaticPaths() {
  return {
    paths: await getDomainsPaths(),
    fallback: 'blocking',
  };
}

export async function getStaticProps({
  params: { origin },
}: {
  params: { origin: string };
}) {
  const [data, dataHome, heroSlidesResp] = await Promise.all([
    await resolvePageDataPath('aboutUs', origin),
    await resolvePageDataPath('home', origin),
    await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/hero-slides`,
      undefined,
      origin,
    ),
  ]);

  const heroSlides = await heroSlidesResp.json();

  return {
    revalidate: 3600 * 24 * 30, // set revalidate interval of 30 days
    props: {
      data,
      dataHome,
      heroSlides: heroSlides?.data.length ? heroSlides.data : null,
    },
  };
}
